import { useState, useCallback } from 'react';
import { createConversionTask } from '../services/conversionApi';

export function useConversionProcess() {
    const [taskId, setTaskId] = useState<string | null>(null);
    const [isCreating, setIsCreating] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const executeTask = useCallback(async (files: File | File[], operation: string, options?: Record<string, unknown>) => {
        setIsCreating(true);
        setError(null);
        try {
            const task = await createConversionTask(files, operation, options);
            setTaskId(task.task_id);
            return task;
        } catch (err: any) {
            const errorMsg = err.response?.data?.detail || err.message || '创建任务失败';
            setError(errorMsg);
            throw err;
        } finally {
            setIsCreating(false);
        }
    }, []);

    const resetTask = useCallback(() => {
        setTaskId(null);
        setError(null);
    }, []);

    return {
        taskId,
        isCreating,
        processError: error,
        setProcessError: setError,
        executeTask,
        resetTask,
    };
}
